export const screenRoutes = {
    HOME: '/',
    DASHBOARD: '/dashboard',
};